<template>
  <div class="index">
    <div class="banner1">
      <img src="../assets/imgs/jpb.png" alt="">
      <p>{{timeCn}}</p>
      <span>数据来源：新华社客户端</span>
    </div>
    <el-table
      :data="olympicRankList"
      stripe
      style="width: 100%;padding-bottom: 1.51rem">
      <el-table-column
        prop="rank"
        label=""
        width="15%">
      </el-table-column>
      <el-table-column
        prop="delegationCn"
        label=""
        width="35%">
      </el-table-column>
      <el-table-column
        prop="goldMedal"
        label=""
        width="11%"
      >
      </el-table-column>
      <el-table-column
        prop="silverMedal"
        label=""
        width="11%">
      </el-table-column>
      <el-table-column
        prop="bronzeMedal"
        label=""
        width="11%">
      </el-table-column>
      <el-table-column
        prop="total"
        label=""
        width="18%">
      </el-table-column>
    </el-table>
<!--    <div class="footer" style="position: fixed;-->
<!--    bottom: 0;-->
<!--    max-width: 7.5rem;-->
<!--    z-index: 99999;-->
<!--    width: 100%;-->
<!--    height: 1.45rem;-->
<!--    background: #fff;padding-top: 0.1rem;padding-bottom: 0.1rem">-->
<!--      <a href="https://gh.guanhai.com.cn/">-->
<!--        <img src="" alt="" style="width: 60%">-->
<!--      </a>-->

<!--    </div>-->

  </div>

</template>

<script>
import {Loading} from "element-ui";

let loading;
const startLoading = () => {
  // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: "加载中……",
    background: "rgba(255, 255, 255, 0.7)",
  });
};
startLoading();
import axios from 'axios'
export default {
  name: "medal",
data() {
return {
olympicRankList: [],
timeCn:''
}
},
  mounted() {
    loading.close();
  },
  created() {
axios.get('https://xhnewsapi.xinhuaxmt.com/userAction/olympic/2024_PARIS_OLYMPICS')
.then(response=>{
console.log(response.data.result.olympicRankList)
if(response.data.code==1000){
this.olympicRankList=response.data.result.olympicRankList;
this.timeCn=response.data.result.timeCn;
}else {
this.$notify({
title:'网络异常，请稍后重试',
type: 'error'
});
}

})
.catch(error=>{

// this.$notify({
//   title:'网络异常，请稍后重试',
//   type: 'error'
// });
})
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.index{
  max-width: 500px;
  margin: 0 auto;
}
.index .banner1{
  position: fixed;
  z-index: 999;
  width: 7.5rem;
}
.index .banner1 img{
  width: 100%;
}
.index .banner1 p{
  position: absolute;
  font-size: 0.18rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #ffffff;
  line-height: 13px;
  top: 1.3rem;
  left: 50%;
  transform:translateX(-50%);
}
.index .banner1 span{
  position: absolute;
  right: 0.1rem;
  bottom: 1rem;
  font-size: 0.18rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #ffffff;
  line-height: 13px;
}
.index .el-table__body{
  width: 100% !important;
}
.index .el-table__header-wrapper{
  display: none;
}
.index .el-table .cell{
  text-align: center;
  font-size: 0.28rem;
}
.index .el-table__row td:nth-of-type(1) .cell{
  font-style: italic;
}
.index .el-table__row td:nth-of-type(3) .cell{
  text-align: center;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.index .el-table__row:nth-of-type(1) td:nth-of-type(1) .cell{
  color: #c37c01;
  border-radius: 0.3rem;
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  background: #f3e5cc;
  padding: 0 0.1rem;
  margin: 0 auto;
}
.index .el-table__row:nth-of-type(2) td:nth-of-type(1) .cell{
  color: #747474;
  border-radius: 0.3rem;
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  background: #dedede;
  padding: 0 0.1rem;
  margin: 0 auto;
}
.index .el-table th, .el-table tr{
  height: 0.8rem;
}
.index .el-table__row:nth-of-type(3) td:nth-of-type(1) .cell{
  color: #bd7a3c;
  border-radius: 0.3rem;
  width: 0.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  background: #f2e4d8;
  padding: 0 0.1rem;
  margin: 0 auto;
}
.index .el-table__empty-text {
  line-height: 60px;
  width: 50%;
  color: #909399;
  position: absolute;
  left: 50%;
  margin-left: -25%;
}
.index .el-table .cell{
  line-height: 0.5rem;
}
.index .el-table {
  position: absolute;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  max-width: 7.5rem;
  font-size: 14px;
  color: #606266;
  top: 2.9rem;
}
</style>




// WEBPACK FOOTER //
// src/pages/medal.vue